// helper function response for handle Multiply  Cases to AD Edit Solicitor Group && to Edit Solicitor User
// the prop object pass  contains 8 parameter which can  be null or not
    //1.value  2.selected 3.checkedCaseTypesIds, 4.caseTypes  5.selectedCaseTypeIndex
    //6.changeAdvancedDisbursementsFormData 7.expenseTypes 8.solicitorGroup
import _ from 'lodash';
export const handleADcaseTypes=(object)=>{
    if (object.checkedCaseTypesIds.includes(object.value)) {
        let index = object.checkedCaseTypesIds.indexOf(object.value);
        if (index > -1) {
            object.checkedCaseTypesIds.splice(index, 1);
        }
        for (let i = 0; i < object.selectedCaseTypes.length; i++) {
            if (object.selectedCaseTypes[i].id === object.value) {
                object.selectedCaseTypeIndex = i;
                break;
            }
        }
        if (object.selectedCaseTypeIndex > -1) {
            object.selectedCaseTypes.splice(index, 1);
        }
        if(object.expenseTypes[object.value]) {
            delete object.expenseTypes[object.value];
        }
        object.changeAdvancedDisbursementsFormData({key:'selectedCaseTypes', value:object.selectedCaseTypes});
        object.changeAdvancedDisbursementsFormData({key:'checkedCaseTypesIds',value: object.checkedCaseTypesIds});
        if(object.expenseTypes) {
            object.changeAdvancedDisbursementsFormData({key:'checkedExpenseTypesPerCaseType',value: object.expenseTypes});
        }
    }
    else {
        object.selectedCaseTypes.push(...object.caseTypes.filter(item => (parseInt(object.value) === item.id)));
        object.checkedCaseTypesIds.push(object.value);
        object.changeAdvancedDisbursementsFormData({key:'selectedCaseTypes',value:object.selectedCaseTypes});
        object.changeAdvancedDisbursementsFormData({key:'checkedCaseTypesIds', value:object.checkedCaseTypesIds});
        if(object.solicitorGroup) {
            object.changeAdvancedDisbursementsFormData({key:'checkedExpenseTypesPerCaseType', value:{
                ...object.solicitorGroup.advancedDisbursementsFormData.checkedExpenseTypesPerCaseType,
                [object.value]: {}
            }});
        }
    }
};

// helper function response for handle Multiply  SubCases to AD Edit Solicitor Group && to Edit Solicitor User
// the prop object pass  contains 5 parameter which can  be null or not
//1.value  2.checkedCaseTypesIds, 3.subCaseTypes  4.selectedCaseTypeIndex
//5.changeAdvancedDisbursementsFormData


export const handleADSubCaseTypes=(propsSubCases)=>{
    if (propsSubCases.checkedSubCaseTypesIds.includes(propsSubCases.value)) {
        let index = propsSubCases.checkedSubCaseTypesIds.indexOf(propsSubCases.value);
        if (index > -1) {
            propsSubCases.checkedSubCaseTypesIds.splice(index, 1);
        }
        for (let i = 0; i < propsSubCases.selectedSubCaseTypes.length; i++) {
            if (propsSubCases.selectedSubCaseTypes[i].id === propsSubCases.value) {
                propsSubCases.selectedSubCaseTypeIndex = i;
                break;
            }
        }
        if (propsSubCases.selectedSubCaseTypeIndex > -1) {
            propsSubCases.selectedSubCaseTypes.splice(index, 1);
        }
        propsSubCases.changeAdvancedDisbursementsFormData({key:'selectedSubCaseTypes', value:propsSubCases.selectedSubCaseTypes});
        propsSubCases.changeAdvancedDisbursementsFormData({key:'checkedSubCaseTypesIds', value:propsSubCases.checkedSubCaseTypesIds});
    }
    else {
        if(propsSubCases.subCaseTypes){
            propsSubCases.selectedSubCaseTypes.push(...propsSubCases.subCaseTypes.filter(item => (parseInt(propsSubCases.value) === item.id)));
        }
        propsSubCases.changeAdvancedDisbursementsFormData({key:'selectedSubCaseTypes',value:propsSubCases.selectedSubCaseTypes});
        propsSubCases.checkedSubCaseTypesIds.push(propsSubCases.value);
        propsSubCases.changeAdvancedDisbursementsFormData({key:'checkedSubCaseTypesIds',value: propsSubCases.checkedSubCaseTypesIds});
    }
}


export const convertCaseSubCaseTypeDTOsToSubCaseTypeState=(payload)=>{
let adSubCaseTypes = [];
    let adSubCaseTypesIds = [];
    _.forEach(payload.disbursementsCaseSubCaseTypeDtos, i => {
        _.forEach(i.subCaseTypes, s => {
            adSubCaseTypes.push({
                id: s.id,
                name: s.name
            });
            adSubCaseTypesIds.push(s.id)
        })
    });
        return {
            adSubCaseTypes: adSubCaseTypes,
            adSubCaseTypesIds:adSubCaseTypesIds
        }
}

//The payload send  due to patch request. It takes 3 props type of array of objects and ids.
export const getAdCaseSubExpenseTypeDtos = (newSolicitor,caseTypes,solicitorGroup) => {
    let dto = [];
    _.forEach(newSolicitor.newSolicitorFormData.selectedCaseTypes, caseType => {
        let dtoItem = {id: '', subCaseTypes: []};
        let cs = _.find(caseTypes.cases, i => {
            return i.id === caseType.id
        });
        dtoItem.id = caseType.id;
        _.forEach(newSolicitor.newSolicitorFormData.selectedSubCaseTypes, subCaseType => {
            let subCase = _.find(cs.subCaseTypes, item => {
                return item.id === subCaseType.id
            })
            if (subCase) {
                dtoItem.subCaseTypes.push({id: subCase.id})
            }
        });
        if(solicitorGroup) {
            _.forEach(solicitorGroup.advancedDisbursementsFormData.checkedExpenseTypesPerCaseType, (value, key) => {
                if (caseType.id.toString() === key) {
                    _.forEach(value, (expenseValue, expenseKey) => {
                        if (expenseValue) {
                            dtoItem.expenseTypeDtos.push({id: parseInt(expenseKey)})
                        }
                    })
                }
            });
        }
        dto.push(dtoItem);
    });
    return dto;
}
